import React from 'react';

import { BuildPath } from '../../../helpers/Paths';

interface DetailsProps {
    userComparisonReport: {
        AddedCount: number 
        RemovedCount: number 
        UpdatedCount: number 
        UnchangedCount: number
        TotalCount: number,
        AddedGroupCount: number,
        UsersInFileCount:number
    },
    userImportId: number
}

const Details = ({userComparisonReport: {AddedCount, RemovedCount, UpdatedCount, UnchangedCount, TotalCount, UsersInFileCount, AddedGroupCount}, userImportId}: DetailsProps) => (
        <>
            
            <div className="upload-result-list">
                <ul>
                    <li>
                        <img alt='' src={`${BuildPath()}/images/userupload/Added.svg`}/> <strong>{AddedCount}</strong> Users Added
                    </li>
                    <li>
                        <img alt='' src={`${BuildPath()}/images/userupload/deactivated.svg`}/> <strong>{RemovedCount}</strong> Users Deactivated
                    </li>
                    <li>
                        <strong>{UpdatedCount}</strong> Users Updated
                    </li>
                    <li>
                        <strong>{UnchangedCount}</strong> Users Unchanged
                    </li>
                    <li>
                        <strong>{UsersInFileCount}</strong> Users in File
                    </li>
                    <li>
                        <strong>{TotalCount}</strong> Total Users Affected
                    </li>       
                    <li>
                        <strong>{AddedGroupCount}</strong> Groups Added
                    </li>     
                </ul>

                <a target="_blank" href={"/api/UserImport/DownloadComparisonFile/" + userImportId}>Download Change Log</a>
            </div>

        </>
);


export default Details;